import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PhoneMockup from '../components/PhoneMockup';

export default function LoginPage() {
  useEffect(() => {
    document.title = 'Login | Chattak';
    document.body.classList.add('login-page');
    return () => {
      document.body.classList.remove('login-page');
    };
  }, []);

  return (
    <div className="page login-page-body">
      <div className="panel-divider"></div>

      {/* LEFT PANEL */}
      <div className="left-panel">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>

        <div className="visual-stage">
          <div className="ring ring-3"></div>
          <div className="ring ring-2"></div>
          <div className="ring ring-1"></div>

          {/* Floating stat card — Sessions */}
          <div className="stat-card card-sessions">
            <div className="stat-card-label">Transactions</div>
            <div className="stat-card-sub">This Month</div>
            <div className="mini-bars">
              {[18,28,14,32,22,36,20,30,16].map((h, i) => (
                <div key={i} className={`mini-bar${i % 2 === 1 ? ' gold' : ''}`} style={{ height: h }}></div>
              ))}
            </div>
            <div className="stat-value">45.1k<span className="stat-change up">+12.6%</span></div>
          </div>

          {/* Phone mockup */}
          <div className="phone-wrap">
            <PhoneMockup />
          </div>

          {/* Floating stat card — Trend */}

          <div className="stat-card card-trend">
            <div className="stat-card-label">Volume</div>
            <div className="stat-card-sub">Last Year</div>
            <svg className="trend-svg" width="140" height="44" viewBox="0 0 140 44">
              <defs>
                <linearGradient id="trendGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#e1a536" stopOpacity="0.4"/>
                  <stop offset="100%" stopColor="#e1a536" stopOpacity="0"/>
                </linearGradient>
              </defs>
              <path d="M0,38 C20,36 30,12 50,14 C70,16 80,30 100,20 C120,10 130,18 140,10" fill="none" stroke="#e1a536" strokeWidth="2" strokeLinecap="round"/>
              <path d="M0,38 C20,36 30,12 50,14 C70,16 80,30 100,20 C120,10 130,18 140,10 L140,44 L0,44 Z" fill="url(#trendGrad)"/>
            </svg>
            <div className="stat-value">175k<span className="stat-change down">-16.2%</span></div>
          </div>
        </div>

        {/* Store buttons — desktop only */}
        <div className="store-buttons store-buttons-desktop">
          <a href="https://apps.apple.com" className="store-btn store-btn-apple" target="_blank" rel="noopener noreferrer">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            <div>
              <div className="store-btn-sub">Download on the</div>
              <div className="store-btn-name">App Store</div>
            </div>
          </a>
          <a href="https://play.google.com" className="store-btn store-btn-google" target="_blank" rel="noopener noreferrer">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M3.18 23.76c.3.17.64.24.99.2l12.6-7.27-2.7-2.7-10.89 9.77zm-1.97-20.6C1.08 3.4 1 3.7 1 4.03v15.94c0 .33.08.63.21.9l.1.09 8.93-8.93v-.2L1.31 3.07l-.1.09zm17.52 8.77l-2.53-1.46-2.99 2.99 2.99 2.99 2.56-1.48c.73-.42.73-1.62-.03-2.04zM4.17.28c-.35-.04-.71.03-1.01.2l10.89 9.77 2.7-2.7L4.17.28z"/></svg>
            <div>
              <div className="store-btn-sub">Get it on</div>
              <div className="store-btn-name">Google Play</div>
            </div>
          </a>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div className="right-panel">
        <Link to="/" className="logo-row">
          <img src="/images/Logo_One_Color.png" alt="Chattak"
            onError={e => { e.target.style.display='none'; e.target.nextElementSibling.style.display='flex'; }} />
          <span className="logo-row-text">Chattak</span>
        </Link>

        <div className="form-outer">
          {/* Blurred form behind overlay */}
          <div className="form-inner" aria-hidden="true">
            <h1 className="form-title">Welcome back</h1>
            <p className="form-sub">Sign in to your Chattak account</p>
            <div className="field-wrap">
              <span className="field-label">Email</span>
              <input className="field-input" type="email" placeholder="your@email.com" tabIndex="-1" />
            </div>
            <div className="field-wrap">
              <span className="field-label">Password</span>
              <input className="field-input" type="password" placeholder="••••••••" tabIndex="-1" />
              <span className="field-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </span>
            </div>
            <div className="form-row">
              <div className="remember-wrap">
                <div className="remember-check">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
                <span className="remember-text">Remember Me</span>
              </div>
              <a href="#" className="forgot-link">Forgot Password?</a>
            </div>
            <button className="btn-signin" tabIndex="-1">Sign In</button>
            <p className="form-footer-text">New on our platform? <a href="#">Create an account</a></p>
          </div>

          {/* COMING SOON OVERLAY */}
          <div className="coming-soon-overlay" role="region" aria-label="Coming soon">
            <div className="cs-badge">Status</div>
            <h2 className="cs-title">Coming<br /><span>Soon</span></h2>
            <p className="cs-subtitle">We're putting the finishing touches on the Chattak experience.</p>
            <div className="cs-notify">
              <div className="cs-notify-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                </svg>
              </div>
              <span className="cs-notify-text">We'll notify you when <strong>it's ready</strong></span>
            </div>
          </div>
        </div>

        {/* Store buttons — mobile only */}
        <div className="store-buttons store-buttons-mobile">
          <a href="https://apps.apple.com" className="store-btn store-btn-apple" target="_blank" rel="noopener noreferrer">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            <div>
              <div className="store-btn-sub">Download on the</div>
              <div className="store-btn-name">App Store</div>
            </div>
          </a>
          <a href="https://play.google.com" className="store-btn store-btn-google" target="_blank" rel="noopener noreferrer">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M3.18 23.76c.3.17.64.24.99.2l12.6-7.27-2.7-2.7-10.89 9.77zm-1.97-20.6C1.08 3.4 1 3.7 1 4.03v15.94c0 .33.08.63.21.9l.1.09 8.93-8.93v-.2L1.31 3.07l-.1.09zm17.52 8.77l-2.53-1.46-2.99 2.99 2.99 2.99 2.56-1.48c.73-.42.73-1.62-.03-2.04zM4.17.28c-.35-.04-.71.03-1.01.2l10.89 9.77 2.7-2.7L4.17.28z"/></svg>
            <div>
              <div className="store-btn-sub">Get it on</div>
              <div className="store-btn-name">Google Play</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
